module.exports = __webpack_public_path__ + "img/vip-banner-diamond.1111cf59.png";